import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Tc, WBotanicaExtendedViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { CodigoEppoNombreCientificoPopupComponent } from '../../../core/components/popup/especies/codigoEppoNombreCientificoPopup.component';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { NombreCientificoService } from '../nombrescientificos/nombrecientifico.service';
import { NombreCientificoViewModel } from '../nombrescientificos/nombrecientifico.types';
import { EspeciesGruposFormasService } from './especiesgruposformas.service';
import { GrupoFormaService } from '../gruposformas/grupoforma.service';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-especiesgruposformas-edit',
    templateUrl: './especiesGruposFormas-edit.component.html',
})
export class EspeciesGruposFormasEditComponent extends ComponentBase implements OnInit {
    @ViewChild(CodigoEppoNombreCientificoPopupComponent) private codigoEppoNombreCientificoPopupComponent: CodigoEppoNombreCientificoPopupComponent;

    editMode: boolean;
    editTitle = 'Nueva';

    listGrupo: Tc[];
    listForma: Tc[];
    listSubForma: Tc[];

    public isCollapsedCabeceraEspecieVegetal = false;
    public isCollapsedDatosEspecieVegetal = false;
    public mostrarBotonBuscar = false;

    especiesGruposFormas: WBotanicaExtendedViewModel;
    visibilitySpinner = false;

    ePhytoReinoUnidoFormaAsociada: boolean;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private especiesGruposFormasService: EspeciesGruposFormasService,
        private nombreCientificoService: NombreCientificoService,
        private grupoFormaService: GrupoFormaService,
        private confirmationService: ConfirmationService,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.especiesGruposFormas = new WBotanicaExtendedViewModel();
    }

    ngOnInit() {
        this.createForm();

        this.globalService.getGrupos().subscribe(res => {
            this.listGrupo = res;
        });

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.especiesGruposFormasService.getDatosWBotanicaExtendedById(id).subscribe(result => {
                this.especiesGruposFormas = result;

                this.globalService.getFormasByGrupo(this.especiesGruposFormas.IdGrupo).subscribe(res => {
                    this.listForma = res;
                });

                this.globalService.getSubFormasByForma(this.especiesGruposFormas.IdForma).subscribe(res => {
                    this.listSubForma = res;
                });

                this.grupoFormaService.getForma(this.especiesGruposFormas.IdForma).subscribe(res => {
                    this.ePhytoReinoUnidoFormaAsociada = res.EphytoReinoUnido;
                });

                //añadir a la lista de nombres cientí­ficos el que tiene asignado actualmente
                let currentNombreCientifico = new Tc();
                currentNombreCientifico.Id = this.especiesGruposFormas.IdNombreCientifico;
                currentNombreCientifico.Descripcion = this.especiesGruposFormas.IdNombreCientificoDescripcion;

                let currentNombreCientificoArray = new Array<Tc>();
                currentNombreCientificoArray.push(currentNombreCientifico);

                //this.form.controls["IdNombreCientifico"].disable();

                this.updateForm();
            });

            this.isCollapsedCabeceraEspecieVegetal = false;
            this.isCollapsedDatosEspecieVegetal = false;

            this.mostrarBotonBuscar = false;
        } else {
            //alta especie

            this.isCollapsedCabeceraEspecieVegetal = false;
            this.isCollapsedDatosEspecieVegetal = false;

            this.mostrarBotonBuscar = true;
        }
    }

    createForm(): void {
        this.form = this.fb.group({
            IdGrupo: [null, Validators.required],
            IdForma: [null, Validators.required],
            IdSubForma: null,
            CodigoEppo: ['', Validators.required],
            IdNombreCientificoDescripcion: ['', Validators.required],
            IdNombreCientifico: null,
            NombreComun: '',
            Activo: [true, Validators.required],
            HabilitadoImportacion: false,
            HabilitadoExportacion: false,
            HabilitadoChina: false,
            EphytoReinoUnido: false,
            AplicaDocumentacion: false,
        });
    }

    updateForm(): void {
        this.form.setValue({
            IdGrupo: this.especiesGruposFormas.IdGrupo,
            IdForma: this.especiesGruposFormas.IdForma,
            IdSubForma: this.especiesGruposFormas.IdSubForma,
            CodigoEppo: this.especiesGruposFormas.CodigoEppo,
            IdNombreCientificoDescripcion: this.especiesGruposFormas.IdNombreCientificoDescripcion,
            NombreComun: this.especiesGruposFormas.NombreComun,
            Activo: this.especiesGruposFormas.Activo,

            HabilitadoImportacion: this.especiesGruposFormas.HabilitadoImportacion,
            HabilitadoExportacion: this.especiesGruposFormas.HabilitadoExportacion,
            HabilitadoChina: this.especiesGruposFormas.HabilitadoChina,
            EphytoReinoUnido: this.especiesGruposFormas.EphytoReinoUnido,

            AplicaDocumentacion: this.especiesGruposFormas.AplicaDocumentacion,
            IdNombreCientifico: this.especiesGruposFormas.IdNombreCientifico,
        });
    }

    onSubmit(): void {
        this.submitted = true;

        if (!this.form.valid) {
            this.isCollapsedCabeceraEspecieVegetal = false;
            this.isCollapsedDatosEspecieVegetal = false;
            return;
        }

        this.visibilitySpinner = true;

        let especiesGruposFormas = new WBotanicaExtendedViewModel();

        especiesGruposFormas = this.form.getRawValue();
        especiesGruposFormas.Id = this.especiesGruposFormas.Id;

        if (this.editMode) {
            if (this.ePhytoReinoUnidoFormaAsociada !== this.form.value.EphytoReinoUnido) {
                this.confirmationService.confirm({
                    message: '¿Está seguro de guardar un valor diferente a la forma asociada en "Ephyto Reino Unido"?',
                    accept: () => {
                        this.especiesGruposFormasService.editEspeciesGruposFormas(especiesGruposFormas).subscribe({
                            next: () => {
                                this.addSuccessMessage('Especie modificada correctamente');
                                this.onBack();
                                this.visibilitySpinner = false;
                            },
                            error: error => {
                                this.catchServerError(error);
                                this.visibilitySpinner = false;
                                this.isCollapsedCabeceraEspecieVegetal = false;
                                this.isCollapsedDatosEspecieVegetal = false;
                            },
                        });
                    },
                    reject: () => {
                        this.visibilitySpinner = false;
                        return;
                    },
                });
            } else {
                this.especiesGruposFormasService.editEspeciesGruposFormas(especiesGruposFormas).subscribe({
                    next: () => {
                        this.addSuccessMessage('Especie modificada correctamente');
                        this.onBack();
                        this.visibilitySpinner = false;
                    },
                    error: error => {
                        this.catchServerError(error);
                        this.visibilitySpinner = false;
                        this.isCollapsedCabeceraEspecieVegetal = false;
                        this.isCollapsedDatosEspecieVegetal = false;
                    },
                });
            }
        } else {
            this.especiesGruposFormasService.createEspeciesGruposFormas(especiesGruposFormas).subscribe({
                next: () => {
                    this.addSuccessMessage('Especie añadida correctamente');
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedCabeceraEspecieVegetal = false;
                    this.isCollapsedDatosEspecieVegetal = false;
                },
            });
        }
    }

    onSearchCodigoEppoNombreCientifico(): void {
        this.codigoEppoNombreCientificoPopupComponent.showDialog(null);
    }

    onBack(): void {
        this.router.navigate(['/mantenimiento/especies/especiesgruposformas']);
    }

    onSelectNombre(): void {
        const idNombreCientifico = this.form.value.IdNombreCientifico;

        //hay que consultar su código Eppo
        this.nombreCientificoService.getDatosNombreCientificoById(idNombreCientifico).subscribe({
            next: result => {
                this.form.patchValue({
                    CodigoEppo: result.CodigoEppo,
                });

                this.isCollapsedDatosEspecieVegetal = false;
            },
            error: error => {
                this.catchServerError(error);
            },
        });
    }

    onSelectGrupo(): void {
        const idGrupo = this.form.value.IdGrupo;

        this.globalService.getFormasByGrupo(idGrupo).subscribe(res => {
            this.listForma = res;
        });
        //limpiar listas que alimentan los combos dependientes
        this.listSubForma = [];

        this.form.patchValue({
            IdForma: null,
            IdSubForm: null,
        });
    }

    onSelectForma(): void {
        const idForma = this.form.value.IdForma;

        if (idForma === null) {
            this.form.patchValue({
                EphytoReinoUnido: false,
            });
        } else {
            this.grupoFormaService.getForma(idForma).subscribe(res => {
                this.ePhytoReinoUnidoFormaAsociada = res.EphytoReinoUnido;

                this.form.patchValue({
                    EphytoReinoUnido: this.ePhytoReinoUnidoFormaAsociada,
                });
            });
        }

        this.globalService.getSubFormasByForma(idForma).subscribe(res => {
            this.listSubForma = res;
        });

        this.form.patchValue({
            IdSubForma: null,
        });
    }

    onAcceptDialogCodigoEppoNombreCientifico(codigoEppoNombreCientifico: NombreCientificoViewModel): void {
        this.form.patchValue({
            CodigoEppo: codigoEppoNombreCientifico.CodigoEppo,
            IdNombreCientificoDescripcion: codigoEppoNombreCientifico.Descripcion,
            IdNombreCientifico: codigoEppoNombreCientifico.Id,
        });
    }
}
